import React, { ReactNode } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { User, VerificationProgress } from '../../types/kyb';

interface LayoutProps {
  children: ReactNode;
  title?: string;
  user: User;
  companyName: string;
  registrationNumber: string;
  taxId: string;
  progress: VerificationProgress;
  rightSidebar?: ReactNode;
  fullWidth?: boolean;
  hideSidebar?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ 
  children, 
  title, 
  user,
  companyName,
  registrationNumber,
  taxId,
  progress,
  rightSidebar,
  fullWidth = false,
  hideSidebar = false
}) => {
  return (
    <div className="flex flex-col h-screen bg-neutral-50 overflow-hidden">
      {/* Fixed Header */}
      <div className="flex-shrink-0 z-10">
        <Header title={title} user={user} />
      </div>
      
      {/* Main Content with Sidebars - All with independent scrolling */}
      <div className="flex-1 flex overflow-hidden">
        {/* Fixed Left Sidebar */}
        {!hideSidebar && (
          <div className="flex-shrink-0 w-72 border-r border-neutral-200 bg-white">
            <Sidebar 
              progress={progress} 
              companyName={companyName}
              registrationNumber={registrationNumber}
              taxId={taxId}
            />
          </div>
        )}
        
        {/* Main Content Area - Scrollable with fixed bottom bar if needed */}
        <div className={`${fullWidth ? 'w-full' : 'flex-1'} flex flex-col overflow-hidden`}>
          {children}
        </div>
        
        {/* Right Sidebar - Independently Scrollable */}
        {rightSidebar && (
          <div className="flex-shrink-0 w-96 overflow-hidden flex flex-col">
            {rightSidebar}
          </div>
        )}
      </div>
    </div>
  );
};

export default Layout;